// TODO: use centralized component between here and activities-desking
// externals
import type { FC } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

// libraries
import type { DealState } from '@makemydeal/dr-dash-types';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// components
import { DealSummaryItemWrapper } from '../common/DealSummaryItemWrapper';

// constants
import * as constants from '../../constants';

// utils
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

// hooks
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';

export type RebatesProps = DealState & { hasDelta?: boolean };

const pickRebateTotalSelector = (usePricedTotal: boolean) =>
    usePricedTotal
        ? offerReduxSelectors.getAppliedIncentivesTotalForDisplay
        : offerReduxSelectors.getAppliedIncentivesTotalForNonDealerCash;

export const Rebates: FC<RebatesProps> = ({ deal, hasDelta = false }) => {
    const useDealRootSelector = createDealRootSelector(deal, 'Rebates');

    const isRestorationEnabled = useSelector(featureToggleSelectors.isProgramIncentivesRestorationEnabled);
    const rebateTotal = useDealRootSelector(pickRebateTotalSelector(isRestorationEnabled), 'rebateTotal');
    const { showDetailedView } = useDealSummary();

    // NOTE: intentionally only showing rebate part of incentives
    return (
        <DealSummaryItemWrapper
            label={constants.REBATES}
            value={formatDollarsAndCents(rebateTotal)}
            useWrapper
            hasDelta={hasDelta}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default Rebates;
